<div class="text-center pt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
